<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page2-bg.jpg">
    <img class="header-phone" src="@/assets/page2-bg-phone.jpg">
    <div class="title-bg"></div>
    <div class="title-text">Ninja Information</div>
    <div class="trans-content">
      <div class="pic-content">
        <div class="transpic">
          <swiper :options="swiperOption" ref="mySwiper" class="swiper-inner">
            <!-- slides -->
            <swiper-slide v-for="(item,index) in translist" :key="index">
              <img :src="item" class="swiper-img">
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="trans-content-phone">
      <div class="pic-content">
        <div class="transpic">
          <swiper :options="swiperOption" ref="mySwiper" class="swiper-inner">
            <!-- slides -->
            <swiper-slide v-for="(item,index) in translistPhone" :key="index">
              <img :src="item" class="swiper-img">
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      config,
      translist: [
        require("@/assets/1.jpg"),
        require("@/assets/2.jpg"),
        require("@/assets/3.jpg"),
        // require("@/assets/4.png"),
        // require("@/assets/5.png"),
      ],
      translistPhone: [
        require("@/assets/1-phone.jpg"),
        require("@/assets/2-phone.jpg"),
        require("@/assets/3-phone.jpg"),
        // require("@/assets/4-phone.png"),
        // require("@/assets/5-phone.png"),
      ],
      //轮播图配置
      swiperOption: {
        loop: true,
        notNextTick: true,
        speed: 300,//设置切换速度，默认300
        autoplay: {
        delay: 3000, //自动切换的时间间隔，单位ms
        stopOnLastSlide: false, //当切换到最后一个slide时停止自动切换
        disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
        reverseDirection: false, //开启反向自动轮播。
        waitForTransition: true, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
        },
        // direction : 'vertical',
        grabCursor : true,
        setWrapperSize :true,
        paginationClickable :true,
        // prevButton:'.swiper-button-prev',
        // nextButton:'.swiper-button-next',
        // scrollbar:'.swiper-scrollbar',
        mousewheelControl : true,
        observeParents:true,
        debugger: true,
        // effect : 'coverflow',
        // slidesPerView: 1.3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 10,
          depth: 200,
          modifier: 2,
          slideShadows: true
        },
        navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
        },
      },
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    background: url(../assets/title-bg.png);
    width: 680px;
    height: 254px;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 220px;
    left: calc(50% - 500px);
  }
  .trans-content{
    position: absolute;
    top: 500px;
    left: calc(50% - 594px);
    .pic-content{
      width: 1188px;
      height: 707px;
      background-size: 100% 100%;
      z-index: 0;
      position: relative;
      margin-bottom: 30px;
    }
    .transpic{
      width: 1188px;
    }
    .swiper-inner{
      width: 1188px;
    }
    .swiper-img{
      width: 1188px;
      height: 707px;
      position: relative;
    }
  }
  .trans-content-phone{
    display: none;
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .trans-content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 30px;
      font-family: titleFont;
      position: absolute;
      top: 36px;
      left: calc(50% - 150px);
    }
    .trans-content{
      display: none;
    }
    .trans-content-phone{
      display: inline-block;
      position: absolute;
      top: 250px;
      left: calc(50% - 260px);
      .pic-content{
        width: 519px;
        height: 360px;
        background-size: 100% 100%;
        z-index: 0;
        position: relative;
        margin-bottom: 30px;
      }
      .transpic{
        width: 519px;
      }
      .swiper-inner{
        width: 519px;
      }
      .swiper-img{
        width: 519px;
        height: 360px;
        background-size: 100% 100%;
        position: relative;
      }
    }
  }
}
</style>